import { createFeatureSelector, createSelector } from '@ngrx/store';
import { COUNTRIES_FEATURE_KEY } from '../keys';
import { CountriesState } from '../reducers/countries-list.reducer';

const selectCountriesState = createFeatureSelector<CountriesState>(COUNTRIES_FEATURE_KEY);

export const selectCountries = createSelector(selectCountriesState, (state: CountriesState) => state.countries);
export const selectCountriesLoaded = createSelector(selectCountriesState, (state: CountriesState) => state.loaded);
export const selectCountriesLoading = createSelector(selectCountriesState, (state: CountriesState) => state.loading);
